import classNames from "classnames";
import LoadingIcon from "../../icons/LoadingIcon"
import './InfiniteLoader.scss';

export default function InfiniteLoader({ fill, className, ...props }) {
  return (
    <LoadingIcon className={classNames("__infinite-loader", className)} style={{ fill }} {...props} />
  );
}
